import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const Marque = () => {
    return (
        <Marquee gradient={false} speed={50} className="custom-marquee-wrapper">
            <h3 className="custom-marquee-text">
                <Sparkles size={18} style={{ marginRight: 8 }} />
                We provide compassionate, professional care for your mental wellness at affordable prices.
                <Sparkles size={18} style={{ marginLeft: 8 }} />
            </h3>
        </Marquee>
    );
};

export default Marque;
